import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LottieAnimationComponent } from '../../shared/components/lottie-animation/lottie-animation.component';
@Component({
  selector: 'app-sign-up-thank-you',
  standalone: true,
  imports: [CommonModule, LottieAnimationComponent],
  templateUrl: './sign-up-thank-you.component.html',
  styleUrl: './sign-up-thank-you.component.scss'
})
export class SignUpThankYouComponent {
  constructor(private router: Router) {}

  navigateToDashboard(): void {
    if (sessionStorage.getItem('roi_pending_calc')) {
      this.router.navigate(['/portal/roi-calculator']);
    } else {
      this.router.navigate(['/portal']);
    }
  }
}
